import { useContext, useState } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './MainSidebar.module.css';
import InerySidebarLogo from '../../assets/logos/inery_navigation_logo.webp';
import { CollapseIcon, ExpandIcon } from 'features/navigation/assets/icons/icons';
import { navigationConfig } from '../../config/navigationConfig';
import MainSidebarAccount from './MainSidebarAccount';
import ThemeContext from 'config/context/themeContext';

const MainSidebar = () => {
  const { dark } = useContext(ThemeContext);
  const [collapsed, setCollapsed] = useState(true);

  return (
    <div className={`${styles.main_sidebar} ${collapsed ? styles.collapsed : ''} ${dark ? styles.dark : ''}`}>
      <div className={styles.main_sidebar_container}>
        <div className={styles.main_sidebar_header}>
          <NavLink to={"/"} className={styles.logo}>
            <img src={InerySidebarLogo} alt="Inery" />
            {!collapsed && <span>Inery DB GUI</span>}
          </NavLink>
        </div>
        <div className={styles.main_sidebar_navigation}>
          {navigationConfig.map((navItem) => (
            <div key={navItem.id} className={styles.nav_link_bucket}>
              <NavLink
                to={navItem.path}
                title={collapsed ? navItem.label : ''}
                className={({ isActive }) =>
                  isActive
                    ? `${styles.main_sidebar_nav_link} ${styles.active}`
                    : styles.main_sidebar_nav_link
                }
              >
                {({ isActive }) => (
                  <>
                    <navItem.icon color={isActive ? "#239DCE" : dark ? "#757575" : ""} />
                    {!collapsed && <span>{navItem.label}</span>}
                  </>
                )}
              </NavLink>
            </div>
          ))}
        </div>
        <div className={styles.main_sidebar_bottom}>
          <MainSidebarAccount collapsed={collapsed} />
          {!collapsed && <button onClick={() => setCollapsed(true)} className={styles.sidebar_collapse_btn}><CollapseIcon color={dark ? "#757575" : ""} /></button>}
          {collapsed && <button onClick={() => setCollapsed(false)} className={styles.sidebar_expand_btn}><ExpandIcon color={dark ? "#757575" : ""} /></button>}
        </div>
      </div>
    </div>
  )
}

export default MainSidebar